export const config = {
  BASE_URL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://bucx.io',
  
  // KLJUČNA IZMENA: Ovde mora ići api.bucx.io ako ti je tamo backend
  API_BASE_URL: process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : 'https://api.bucx.io/api',
  
  DEV_API_URL: 'http://localhost:5000/api',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production'
};

export const getApiUrl = () => {
  return config.isProduction ? config.API_BASE_URL : config.DEV_API_URL;
};

export const getApiOrigin = () => getApiUrl().replace(/\/api\/?$/, '');

export const getAssetUrl = (assetPath) => {
  if (!assetPath) return null;
  if (/^(https?:|data:|blob:)/i.test(assetPath)) return assetPath;
  return `${getApiOrigin()}${assetPath.startsWith('/') ? '' : '/'}${assetPath}`;
};
